import PropTypes from 'prop-types'
import {clusterCountLayerHousehold, clusterLayerHousehold, unclusteredLayerHousehold} from './config'
import {Source, Layer} from '../MaptilerWrapper'
import {useEffect, useMemo} from 'react'
import {loadOutreachSimulationImage} from '../helpers'
import {useMap} from '../../../../../store/hooks/map'

const UniqueHouseHoldsClusterLayer = ({data = {}, isOutreachSimulationSelected = false, isPersonaSelected = false}) => {
  const {mapRef} = useMap()

  // Load outreach simulation image
  useEffect(() => {
    if (mapRef) {
      loadOutreachSimulationImage(mapRef?.current, 'multicolor-circle')
    }
  }, [mapRef])

  // Render grouped layers
  const renderGroupedLayers = useMemo(() => {
    if (!Array.isArray(data)) return null

    return data.map((group, i) => (
      <Source
        key={`uniqueHouseholdsCluster${group.key}`}
        id={`uniqueHouseholdsSource${group.key}`}
        type='geojson'
        data={group.data}
        cluster={true}
        clusterMaxZoom={12}
        clusterRadius={30}
        clusterMinPoints={150}
      >
        {group?.layers?.map((layer, j) => (
          <Layer beforeId={i !== 0 && j === 0 ? data[i - 1].layers[j].id : undefined} key={layer.id} {...layer} />
        ))}
      </Source>
    ))
  }, [data])

  // Render default layers
  const renderDefaultLayers = useMemo(
    () => (
      <Source
        key='uniqueHouseholdsCluster'
        id='uniqueHouseholdsSource'
        type='geojson'
        data={data}
        cluster={true}
        clusterMaxZoom={12}
        clusterRadius={30}
        clusterMinPoints={1000}
      >
        <Layer {...clusterLayerHousehold} />
        <Layer {...clusterCountLayerHousehold} />
        <Layer {...unclusteredLayerHousehold} />
      </Source>
    ),
    [data]
  )

  // Determine which layers to render
  return isOutreachSimulationSelected || isPersonaSelected ? renderGroupedLayers : renderDefaultLayers
}

UniqueHouseHoldsClusterLayer.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  isOutreachSimulationSelected: PropTypes.bool,
  isPersonaSelected: PropTypes.bool
}

export default UniqueHouseHoldsClusterLayer

/**
 * List of functions and their purpose:
 *
 * - UniqueHouseHoldsClusterLayer: Renders clustered or unclustered layers for unique households based on outreach simulation or persona selection.
 * - renderGroupedLayers: Renders grouped layers for unique households with clustering enabled.
 * - renderDefaultLayers: Renders default layers for unique households with clustering and unclustered points.
 */
